import _ from "lodash";

const PAID_PAYMENT_STATUSES = ["PAID", "SETTLED"];

function lineItemsKey(items) {
  return (items || [])
    .map(
      (i) =>
        `${i.item ?? ""}|${i.currency ?? ""}|${i.qty ?? 1}|${i.unitPrice ?? 0}|${i.price ?? 0}`,
    )
    .sort()
    .join(";");
}

export function debitNoteLineItemsChanged(beforeItems, afterItems) {
  return lineItemsKey(beforeItems) !== lineItemsKey(afterItems);
}

export function debitNoteChargeOrCostChanged(snapshot, payload) {
  if (!snapshot) return false;
  return (
    debitNoteLineItemsChanged(snapshot.chargeItems, payload.chargeItems) ||
    debitNoteLineItemsChanged(snapshot.costItems, payload.costItems)
  );
}

export function isPaidExpiringDebitNote(snapshot) {
  if (!snapshot) return false;
  if (!PAID_PAYMENT_STATUSES.includes(snapshot.paymentStatus)) return false;
  return Boolean(snapshot.renewal || snapshot.renewalStatus === "PENDING");
}

/**
 * Confirm before saving charge/cost changes on a paid debit note tied to renewal.
 * Returns true when save should proceed.
 */
export function confirmPaidExpiringDebitNoteChargeSave(snapshot, payload) {
  if (!isPaidExpiringDebitNote(snapshot)) return true;
  if (!debitNoteChargeOrCostChanged(snapshot, payload)) return true;

  return window.confirm(
    "This debit note is already paid and has a pending renewal. Saving charge or cost item changes may increase the total and change payment status (e.g. to PARTIAL). Continue?",
  );
}

/**
 * Confirm before any full debit note save when charge/cost items differ from load snapshot.
 * Returns true when save should proceed.
 */
export function confirmDebitNoteChargeSaveIfChanged(snapshot, payload) {
  if (!debitNoteChargeOrCostChanged(snapshot, payload)) return true;
  if (isPaidExpiringDebitNote(snapshot)) {
    return confirmPaidExpiringDebitNoteChargeSave(snapshot, payload);
  }

  return window.confirm(
    "Charge or cost items have changed since this form was loaded. Continue saving these changes?",
  );
}

export function buildDebitNoteSavedSnapshot(data) {
  if (!data) return null;
  return {
    chargeItems: _.cloneDeep(data.chargeItems),
    costItems: _.cloneDeep(data.costItems),
    paymentStatus: data.paymentStatus,
    renewal: data.renewal,
    renewalStatus: data.renewalStatus,
  };
}
